/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_UsdInputs */

const cs_currency_usd = /** @type {(inputs: Currency_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD — americký dolar`)
};

const en_currency_usd = /** @type {(inputs: Currency_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD — US dollar`)
};

/**
* | output |
* | --- |
* | "USD — US dollar" |
*
* @param {Currency_UsdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const currency_usd = /** @type {((inputs?: Currency_UsdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_UsdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currency_usd(inputs)
	return cs_currency_usd(inputs)
});